import { ReactNode } from 'react';
import { Trans as ComponentTrans, useTranslation as i18nUseTranslation } from 'next-i18next';

type I18nFnParams = Parameters<typeof i18nUseTranslation>;
type I18nReturnValue = ReturnType<typeof i18nUseTranslation>;
type I18nFnTType = I18nReturnValue['t'];

type I18nFnTWithRich = I18nFnTType & {
  rich: (key: string, values?: Record<string, string>) => ReactNode;
};
type ReturnValue = I18nReturnValue & {
  t: I18nFnTWithRich;
};

// Guard used just for assertion for ts
const isHaveRich = (value: unknown): value is I18nFnTWithRich => {
  return Boolean(value);
};

export const useTranslation = (...props: I18nFnParams): ReturnValue => {
  const value = i18nUseTranslation(...props);

  if (isHaveRich(value.t)) {
    value.t.rich = (key: string, values?: Record<string, string>) => (
      <ComponentTrans
        t={value.t}
        i18nKey={key}
        components={{ b: <b />, br: <br /> }}
        values={values}
      />
    );
  }

  return value as ReturnValue;
};
